import { Injectable } from '@angular/core';

//services
import { HTTPrequestService } from './httprequest.service';

// declare const Notification: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  // private notificationWelcome:NotificationModel = {
  //   title: `Welcome to Notification Button`,
  //   description: `Now, you can receive our notifications`,
  //   logoImage: `assets/img/green-button.png`,
  //   image: '',
  //   targetUrl: '',
  //   buttons: {
  //     button1:{
  //       text: '',
  //       imageUrl: '',
  //       url: ''
  //     },
  //     button2:{
  //       text: '',
  //       imageUrl: '',
  //       url: ''
  //     }
  //   }
  // }

  // private notificationBasicButtons:NotificationModel = {
  //   title: `Demo Basic Notification`,
  //   description: `Begin to send notifications now, it' free`,
  //   logoImage: 'assets/img/green-button.png',
  //   image: '',
  //   targetUrl: 'https://notificationButton.com',
  //   buttons: {
  //     button1:{
  //       text: 'Ver Precios',
  //       imageUrl: 'assets/img/green-button.png',
  //       url: 'https://notificationButton.com/pricing'
  //     },
  //     button2:{
  //       text: 'Ver Funciones',
  //       imageUrl: 'assets/img/green-button.png',
  //       url: 'https://notificationButton.com/pricing'
  //     }
  //   }
  // }

  // private notificationImageButtons:NotificationModel = {
  //   title: `Demo Image Notification`,
  //   description: `SignUp Free Now !!!`,
  //   logoImage: 'assets/img/green-button.png',
  //   image: 'assets/img/App-Notification-Design.jpg',
  //   targetUrl: 'https://notificationButton.com',
  //   buttons: {
  //     button1:{
  //       text: 'Ver Precios',
  //       imageUrl: 'assets/img/green-button.png',
  //       url: 'https://notificationButton.com/pricing'
  //     },
  //     button2:{
  //       text: 'Ver Funciones',
  //       imageUrl: 'assets/img/green-button.png',
  //       url: 'https://notificationButton.com/pricing'
  //     }
  //   }
  // }

  public lang:string = 'en';

  // private notificationStatus:any = Notification; // gets errors en mobile IOS

  constructor( private _requestHttp: HTTPrequestService ) {

  }

  sendNotification( template?:any, user_id?:any ){
  // sendNotification( type?:string, newNotification?:any, template?:any, user_id?:any ){
    // switch(type){
    //   case 'basic': {
    //     console.log('envío notification basic', this.notificationBasicButtons)
    //     break;
    //   }
    //   case 'image': {
    //     console.log('envío notification image', this.notificationImageButtons)
    //     break;
    //   }
    //   case 'custom': {
    //     console.log('envío notification custom', newNotification)
    //     break;
    //   }
    //   default: {
    //     console.log('envío notification default', this.notificationWelcome)
    //     break;
    //   }
    //
    // }

    let data = {
      user_id: user_id,
      lang: this.lang
    }
    this._requestHttp.requestPost('https://notificationbutton.com/api/account/testing/sendNotification/'+template, data ).subscribe( ()=>{
      console.log('se envío la notificacion demo')
    },
    error =>{
      console.log('NO se envío la notificacion demo: ', error)
    })


  }
}


export interface NotificationModel{
  title:string
  description: string
  logoImage: string
  image?: string
  targetUrl: string
  buttons?: {
    button1: {
      text: string
      imageUrl?: string
      url: string
    },
    button2: {
      text: string
      imageUrl?: string
      url: string
    }
  }

}
